<template>
	<div id="setting">
		<van-cell-group>
			<van-cell title="团队介绍" is-link @click="run('/team')" />
			<van-cell title="更换头像" is-link @click="run('/image_update')" />
			<van-cell title="修改密码" is-link @click="run('/change_password')" />
			<van-cell title="帮助中心" is-link @click="run('/help')" />
			<van-cell title="软件版本" value="V2.0" />
		</van-cell-group>
			<van-button size="large" style="background-color: red;color: white;" @click="logout">退出</van-button>
	</div>
</template>

<script>
	import { Row, Col, Icon, Cell, CellGroup, Button, Dialog } from 'vant';
	import axios from 'axios';
	import global from '@/api/global';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	Vue.use(VueCookies);
	export default {
		components: {
			[Row.name]: Row,
			[Col.name]: Col,
			[Icon.name]: Icon,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Dialog.name]: Dialog
		},
		created: function() {},
		data() {
			return {

			}
		},
		methods: {
			logout() {
				Dialog.confirm({
					title: '退出',
					message: '是否退出？'
				}).then(() => {
					this.$cookies.remove("auth_token");
					this.$router.push({ //核心语句
						path: '/login' //跳转的路径
					});
					// on confirm
				}).catch(() => {
					// on cancel
				});
			},
			run(p) {
				this.$router.push({
					path: p
				});
			}
		}
	};
</script>

<style>
	#setting .van-button {
		margin-top: 20px;
		color: white;
		width: 90%;
		margin-left: 5%;
		border-radius: 5px;
	}
</style>